import React from "react";
import { Box, Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

interface ItemProps {
  path: string;
  children: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const useStyles = makeStyles({
  item: {
    listStyle: "none",
  },
});

export const Item: React.FC<ItemProps> = ({ path, children, onClick }) => {
  const classNames = useStyles();

  return (
    <Box
      component="li"
      className={classNames.item}
      mx={1}
      fontWeight="fontWeightMedium"
    >
      {onClick ? (
        <Link href={path} color="primary" onClick={onClick}>
          {children}
        </Link>
      ) : (
        <Link component={RouterLink} color="primary" to={path}>
          {children}
        </Link>
      )}
    </Box>
  );
};
